<div class="d-flex align-items-center justify-content-start text-muted cache-indicator-container">
    <ng-container *ngIf="cachedAt">
        <span class="border-bottom" [ngClass]="{
            'cache-refreshed': justRefreshed,
            'border-secondary': ageColor === CACHE_AGE_COLORS.SECONDARY,
            'border-warning': ageColor === CACHE_AGE_COLORS.WARNING,
            'border-danger': ageColor === CACHE_AGE_COLORS.DANGER
        }">
            <ng-container *ngIf="justRefreshed">
                <fa-icon [icon]="['far', 'check']" [ngClass]="{
                    'text-secondary': ageColor === CACHE_AGE_COLORS.SECONDARY,
                    'text-warning': ageColor === CACHE_AGE_COLORS.WARNING,
                    'text-danger': ageColor === CACHE_AGE_COLORS.DANGER
                }" class="me-1"></fa-icon>
                {{ 'common.cache-indicator.data-updated' | translate:{ name: name } }}
            </ng-container>
            <ng-container *ngIf="!justRefreshed">
                {{ 'common.cache-indicator.data-as-of' | translate:{ name: name } }} {{ cachedAt | date:'shortTime' }}
            </ng-container>
        </span>
        <span class="mx-2"></span>
        <button
            *ngIf="!justRefreshed"
            class="btn btn-sm ms-2"
            [ngClass]="{
                'btn-outline-secondary': ageColor === CACHE_AGE_COLORS.SECONDARY,
                'btn-outline-warning': ageColor === CACHE_AGE_COLORS.WARNING,
                'btn-outline-danger': ageColor === CACHE_AGE_COLORS.DANGER
            }"
            [disabled]="loading"
            (click)="onRefresh()">
            <fa-icon [icon]="['far', 'sync']" class="me-1" />
            {{ 'common.cache-indicator.reload' | translate }}
        </button>
    </ng-container>
</div>
